import { createFeature, createReducer, on } from '@ngrx/store';

import { done, error, getInitialProgressState, MasterData, ProgressState, running } from 'app/shared/models';
import {
    loadMasterDataCancelled,
    loadMasterDataFailure,
    loadMasterDataFromServer,
    loadMasterDataSuccess,
    preloadMasterDataFinished,
    resetMasterDataState,
} from 'app/state/master-data/master-data.actions';

export const masterDataFeatureKey = 'masterData';

export interface MasterDataState {
    masterData: MasterData | undefined;
    loadFromServerProgress: ProgressState;
}

export const initialState: MasterDataState = {
    masterData: undefined,
    loadFromServerProgress: getInitialProgressState(),
};

export const reducer = createReducer(
    initialState,
    on(
        loadMasterDataFromServer,
        (state): MasterDataState => ({
            ...state,
            loadFromServerProgress: running(),
        }),
    ),
    on(preloadMasterDataFinished, (state, { masterData }): MasterDataState => {
        if (state.masterData) return state;
        return {
            ...state,
            masterData,
        };
    }),
    on(
        loadMasterDataSuccess,
        (state, { masterData }): MasterDataState => ({
            ...state,
            masterData,
            loadFromServerProgress: done(),
        }),
    ),
    on(
        loadMasterDataFailure,
        (state): MasterDataState => ({
            ...state,
            loadFromServerProgress: error(),
        }),
    ),
    on(
        loadMasterDataCancelled,
        (state): MasterDataState => ({
            ...state,
            loadFromServerProgress: getInitialProgressState(),
        }),
    ),
    on(
        resetMasterDataState,
        (): MasterDataState => ({
            ...initialState,
        }),
    ),
);

export const masterDataFeature = createFeature({
    name: masterDataFeatureKey,
    reducer,
});
